module.exports = __webpack_public_path__ + "img/Service.01fc82e6.png";